import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import PublicLayout from "./components/layout/PublicLayout";
import AdminLayout from "./components/layout/AdminLayout";
import Home from "./pages/Home";
import PublicPartners from "./pages/PublicPartners";
import PartnerDetail from "./pages/PartnerDetail";
import Residents from "./pages/Residents";
import About from "./pages/About";
import Business from "./pages/Business";
import PortalPage from "./pages/portal/PortalPage";
import InvoicingPage from "./pages/portal/InvoicingPage";
import Proposal from "./pages/Proposal";
import ProposalBudget from "./pages/ProposalBudget";
import AdminLogin from "./pages/portal/AdminLogin";
import AdminDashboard from "./pages/portal/AdminDashboard";
import Partners from "./pages/portal/Partners";

// Auth0 Configuration
const AUTH0_DOMAIN = "dev-szqg12ejy5yc6hih.ca.auth0.com";
const AUTH0_CLIENT_ID = "CYJiD2Tr0E52GvUdzQ0VfyHEesJEYoca";

function App() {
  return (
    <BrowserRouter>
      <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin + "/portal",
        }}
        cacheLocation="localstorage"
      >
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/partners" element={<PublicPartners />} />
            <Route path="/partners/:id" element={<PartnerDetail />} />
            <Route path="/residents" element={<Residents />} />
            <Route path="/business" element={<Business />} />
            <Route path="/about" element={<About />} />
            <Route path="/governance" element={<div className="p-10">Governance Page Placeholder</div>} />
            <Route path="/news" element={<div className="p-10">News & Events Placeholder</div>} />
          </Route>

          {/* Auth0 Portal - Partner Portal with iframe */}
          <Route path="/portal" element={<PortalPage />} />
          <Route path="/portal/login" element={<Navigate to="/portal" replace />} />

          {/* Partner Invoicing Portal */}
          <Route path="/partner-invoicing" element={<InvoicingPage />} />

          {/* Website Proposal */}
          <Route path="/proposal" element={<Proposal />} />
          <Route path="/proposal/budget" element={<ProposalBudget />} />

          {/* Admin Routes - Existing JWT Auth */}
          <Route path="/portal/admin-login" element={<AdminLogin />} />
          <Route path="/portal/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/portal/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="partners" element={<Partners />} />
          </Route>
        </Routes>
      </Auth0Provider>
    </BrowserRouter>
  );
}

export default App;
